import { t } from 'i18next'
import { EXCEPTION_STATUS } from 'src/app/shared/constants/common.constants'
import { SUMMARY_TYPE_GROUP_TABLE } from 'src/app/shared/models/Exception.model'
import { QuickExceptionSetTabs } from '.'

const formatData = (data: Array<any>) => {
  return data?.map((item: any) => ({
    ...item,
    transactionGroup:
      item?.status === EXCEPTION_STATUS.EXCEPTION
        ? SUMMARY_TYPE_GROUP_TABLE.DECISIONS_NEEDED
        : SUMMARY_TYPE_GROUP_TABLE.DECISIONED
  }))
}

const tabTitle = (tab: QuickExceptionSetTabs) => {
  switch (tab) {
    case QuickExceptionSetTabs.Ach:
      return t('QuickExceptionSetup:quick_exception_setup.ach')
    case QuickExceptionSetTabs.Check:
      return t('QuickExceptionSetup:quick_exception_setup.check')
    default:
      return ''
  }
}

export { formatData, tabTitle }

